
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#55A3FF","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.607 2.012a.754.754 0 00-.266 0H8.084C5.596 2.012 3.5 4.03 3.5 6.49v10.713c0 2.6 2.004 4.66 4.584 4.66h7.989c2.453 0 4.479-2.161 4.479-4.66V8.038a.75.75 0 00-.21-.52l-5.064-5.275a.75.75 0 00-.541-.231h-.13zm-.883 1.5h-5.64C6.412 3.512 5 4.872 5 6.49v10.713c0 1.781 1.342 3.16 3.084 3.16h7.989c1.602 0 2.979-1.468 2.979-3.16v-8.22l-.876.002c-.334 0-.713 0-1.135-.002a3.324 3.324 0 01-3.312-3.136l-.005-.189V3.511zm4.506 3.972h-1.186a1.824 1.824 0 01-1.82-1.825V4.353l3.006 3.131zm-3.946 7.324a.75.75 0 01.102 1.493l-.102.007H8.887a.75.75 0 01-.102-1.493l.102-.007h5.397zm-1.291-4.202a.75.75 0 00-.75-.75H8.887l-.102.006a.75.75 0 00.102 1.494h3.356l.101-.007a.75.75 0 00.649-.743z","fill":"inherit"}})])
          )
        }
      }
    